import { RecalculatePriceStrategy } from '@ui/features/quote-builder/state/calculations/types';

import { recalculateTargetGrossMargin } from './target-gross-margin';

export const recalculateNewPart = {
  onQuantityChange: recalculateTargetGrossMargin.onQuantityChange,
  onUnitPriceChange: recalculateTargetGrossMargin.onUnitPriceChange,
  onGrossMarginChange: recalculateTargetGrossMargin.onGrossMarginChange,
  onContributionMarginChange: null,
  onBaseGrossMarginChange: null,
  onQuotePriceCreation: recalculateTargetGrossMargin.onQuotePriceCreation,
  onUnitCostChange: null,
} satisfies RecalculatePriceStrategy;
